import { createContext, useContext, useState, useCallback } from 'react';

const CarrinhoComprasLojaFisicaContext = createContext(null);

export const CarrinhoComprasLojaFisicaProvider = ({ children }) => {
  const [itens, setItens] = useState([]);
  const [modoAtivo, setModoAtivo] = useState(false);

  const ativarModo = useCallback(() => setModoAtivo(true), []);
  const desativarModo = useCallback(() => setModoAtivo(false), []);
  const toggleModo = useCallback(() => setModoAtivo(prev => !prev), []);

  const adicionarItem = useCallback((produto, quantidade) => {
    setItens(prev => {
      const codigo = produto.codigo || produto.codigoInterno;
      const existente = prev.find(i => (i.produto.codigo || i.produto.codigoInterno) === codigo);
      if (existente) {
        return prev.map(i =>
          (i.produto.codigo || i.produto.codigoInterno) === codigo
            ? { ...i, quantidade: Number(quantidade) }
            : i
        );
      }
      return [...prev, { produto, quantidade: Number(quantidade) }];
    });
  }, []);

  const removerItem = useCallback((codigo) => {
    setItens(prev => prev.filter(i => (i.produto.codigo || i.produto.codigoInterno) !== codigo));
  }, []);

  const atualizarQuantidade = useCallback((codigo, quantidade) => {
    const qtd = Number(quantidade);
    if (isNaN(qtd) || qtd <= 0) {
      removerItem(codigo);
      return;
    }
    setItens(prev =>
      prev.map(i =>
        (i.produto.codigo || i.produto.codigoInterno) === codigo
          ? { ...i, quantidade: qtd }
          : i
      )
    );
  }, [removerItem]);

  const limparCarrinho = useCallback(() => setItens([]), []);

  const estaNoCarrinho = useCallback((codigo) => {
    return itens.some(i => (i.produto.codigo || i.produto.codigoInterno) === codigo);
  }, [itens]);

  const getQuantidade = useCallback((codigo) => {
    const item = itens.find(i => (i.produto.codigo || i.produto.codigoInterno) === codigo);
    return item ? item.quantidade : 0;
  }, [itens]);

  const totalItens = itens.length;

  return (
    <CarrinhoComprasLojaFisicaContext.Provider value={{
      itens,
      modoAtivo,
      totalItens,
      ativarModo,
      desativarModo,
      toggleModo,
      adicionarItem,
      removerItem,
      atualizarQuantidade,
      limparCarrinho,
      estaNoCarrinho,
      getQuantidade,
    }}>
      {children}
    </CarrinhoComprasLojaFisicaContext.Provider>
  );
};

export const useCarrinhoComprasLojaFisica = () => {
  const ctx = useContext(CarrinhoComprasLojaFisicaContext);
  if (!ctx) throw new Error('useCarrinhoComprasLojaFisica deve ser usado dentro de CarrinhoComprasLojaFisicaProvider');
  return ctx;
};

export default CarrinhoComprasLojaFisicaContext;
